<template>
  <div
    v-tooltip="model"
    class="range-slider__wrapper"
  >
    <label
      :for="uniqueId"
      hidden
    >Range slider</label>
    <input
      :id="uniqueId"
      v-model="model"
      :max="max"
      :min="min"
      :style="{ '--slider-filled-width': `${100 / max * model}%` }"
      aria-label="Range slider"
      class="range-slider"
      type="range"
    >
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  min?: number
  max?: number
}>(), {
  min: 1,
  max: 100,
});
const uniqueId = useId();
const model = defineModel();
</script>

<style lang="scss" scoped>
.range-slider {
  --slider-filled-width: 0%;

  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: linear-gradient(101.99deg, rgb(88, 226, 176) -3.52%, #3EB0D3 var(--slider-filled-width), var(--gray) var(--slider-filled-width), var(--gray) 100%);
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;
  border-radius: 5px;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: var(--accent-primary);
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: var(--accent-primary);
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  }

  &::-ms-thumb {
    width: 20px;
    height: 20px;
    background: var(--accent-primary);
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  }

  &:focus::-webkit-slider-thumb {
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.8);
  }

  &:focus::-moz-range-thumb {
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.8);
  }

  &:focus::-ms-thumb {
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.8);
  }
}
</style>
